export var KNOLL_BUSINESS_UNIT_CODE = 'KnollNAConfigure';
export var CONFIG_SYSTEM_FEATURE_DESCRIPTION = 'Config System';
export var CPQ_JDE_OPTION_DESCRIPTION = 'CPQ|JDE';
export var CPQ_JDE_MFG_OPTION_MODEL_CODE = 'cpq_jde';
export var OPTIONS_PRODUCT_CLASS = 'OPTIONS';
export var WORKORDER_PRODUCT_CLASS = 'WORKORDER';
export var validateRangeInput = function (range, rangeInput) {
    if (!range || !rangeInput || rangeInput === '')
        return true;
    if (Number.isNaN(+rangeInput))
        return false;
    var start = range.start, end = range.end, increment = range.increment, rangeScale = range.rangeScale;
    var textAsNumber = +rangeInput;
    // Check if value is within range bounds
    if (textAsNumber < start || textAsNumber > end)
        return false;
    // Use integer arithmetic to avoid floating-point precision issues
    var scaledVal = Math.round(textAsNumber * Math.pow(10, rangeScale));
    var scaledIncrement = Math.round(increment * Math.pow(10, rangeScale));
    var scaledStart = Math.round(start * Math.pow(10, rangeScale));
    // Check if the value matches the increment pattern from the start value
    if ((scaledVal - scaledStart) % scaledIncrement !== 0)
        return false;
    return true;
};
export var replaceProductNbrPlaceholder = function (originalProductNbr, placeholder, replaceText) {
    return originalProductNbr.replace(placeholder, replaceText);
};
